export default function EditNavDemoDialogController(
  $scope,
  $filter,
  $timeout,

  ssDialogService,
  loaderService,
  alerts
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleEditDemoSubmit = _handleEditDemoSubmit;
  vm.handleNavToDemo = _handleNavToDemo;

  _activate();

  // //////// METHODS //////////

  function _activate() {

  }

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.demo.editNavDemoDialog);
  }

  function _handleEditDemoSubmit() {
    if ($scope.editDemoForm.$valid) {
      loaderService.showViewLoader = true;
      _closeDialog().then(() => {
        loaderService.showViewLoader = false;
        alerts.success('The Demo has saved successfully.');
      });
    }
  }

  function _handleNavToDemo(demoNavItemId) {
    const newActiveDemo = $filter(
      'filter'
    )(
      vm.demo.demoNavItems,
      {
        demoNavItemId,
      },
      true
    )[0];
    if (vm.activeDemoNavItem !== newActiveDemo) {
      vm.contentPaneIsFaded = true;
      $timeout(
        () => {
          vm.activeDemoNavItem = newActiveDemo;
          vm.contentPaneIsFaded = false;
        },
        200
      );
    }
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.demo.editNavDemoDialog);
  }
}

EditNavDemoDialogController.$inject = [
  '$scope',
  '$filter',
  '$timeout',

  'ssDialogService',
  'loaderService',
  'alerts',
];
